import { IWeightTypeRate } from "@cai-services";

/**
 * Class WeightTypeRate
 */
export class WeightTypeRate implements IWeightTypeRate {
  weightId: number;
  weightType: string;
  weight: number;

  constructor (weightId?: number, weightType?: string, weight?: number) {
    this.weightId = weightId;
    this.weightType = weightType;
    this.weight = weight;
  }
}
